import { configureStore } from '@reduxjs/toolkit'
import loginReducer from './features/login/loginSlice'
import equipmentReducer from './features/equipment/equiplmentSlice'
import anomalyReducer from './features/anomalyRegistration/anomalySlice'
import userReducer from './features/userProfile/userSlice'
import tableReducer  from './features/dbTable/dbTablSlice'
import usersReducer from './features/usersTable/usersTableSlice'
import supportReducer from './features/support/supportSlice'

const store = configureStore({
  reducer: {
    login: loginReducer,
    equipment: equipmentReducer,
    anomaly: anomalyReducer,
    user:userReducer,
    table:tableReducer,
    users:usersReducer,
    support:supportReducer,
  },
  //middleware:(getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
})
export default store;
